export function formatNumber(n?: number): string {
  if (!n) {
    return '0'
  }
  return n % 1 !== 0 ? n.toFixed(2) : n.toString()
}
